module.exports = __webpack_public_path__ + "img/external-link.46a9dd31.svg";